import { createContext } from 'react';
import iUser from '../interfaces/User';
import iSerial from '../interfaces/Serial';

interface IUsersSerialsContextProps {
  users: iUser[];
  serials: iSerial[];
  reportDate:  string;
  setReportDate: (date: string) => void;
  setSerial: (serial: iSerial) => void;
  setUsersSerials: ({
    users,
    serials,
  }: {
    users: iUser[];
    serials: iSerial[];
  }) => void;
}

export default createContext({} as IUsersSerialsContextProps);
